import {Service} from "@/services/superclasses/service";
import {IdName} from "@/interfaces/superclasses/id-name";

const api = window.contextPath + '/rest/supplement-categories';

export class SupplementCategoryService extends Service {

    public loadAll = async (): Promise<IdName[]> => {
        return this.data(await this.get<IdName[]>(api))
    }
}

export const supplementCategoryService = new SupplementCategoryService()